class Formatter {
  static round(number, fixed = 2) {
    return !number ? 0 : Number(number.toFixed(fixed));
  }

  static truncateString(string, numberOfChars) {
    if (typeof string !== 'string' || typeof numberOfChars !== 'number') {
      throw new Error('Invalid input types');
    }

    if (numberOfChars <= 0) {
      throw new Error('Number of characters must be greater than 0');
    }
    const trimmedString = string.trim();

    if (trimmedString.length <= numberOfChars) {
      return trimmedString;
    }

    return `${trimmedString.slice(0, numberOfChars)}...`;
  }
}

export default Formatter;
